<template>
    <div>
        <div class="form-group">
            <label class="form-label">{{$t('label.bizName')}}</label>
            <div class="input-group bg-white shadow-inset-2">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-right-0">
                        <i class="fas fa-store-alt"></i>
                    </span>
                </div>
                <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.bizName')" v-model="bizName">
            </div>
        </div>
        <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="hideMobile" v-model="nHideMobile">
            <label class="custom-control-label" for="hideMobile">{{$t('label.hide_mobile')}}</label>
        </div>
        <div class="border-bottom mt-5 mb-3">
            <h4>{{$t('header.address')}}</h4>
        </div>
        <div class="form-group" v-for="(add, index) in address" :key="index">
            <label class="form-label">{{$t('label.address')}} {{index + 1}}</label>
            <div class="input-group bg-white shadow-inset-2">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-right-0">
                        <i class="fas fa-map-marker-alt"></i>
                    </span>
                </div>
                <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.address') + (index + 1)" v-model="receiptAddress[index]">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'receiptContent',
    props:{
        bizName:{ type: String },
        hideMobile:{ type: Number },
        address:{ type: Array }
    },
    computed:{
        nHideMobile:{
            get(){ return this.hideMobile === 1 ? true : false },
            set(value){ this.hideMobile = value ? 1 : 0 }
        },
        receiptAddress(){
            var ret = [];
            for(var i=0; i<this.address.length; i++){
                ret.push(this.address[i]);
            }
            return ret;
        }
    },
    methods:{
        submitReceipt(){
            var data = {
                bizName: this.bizName,
                hideMobile: this.hideMobile,
                address: this.receiptAddress
            }
            return data;
        }
    }
}
</script>